import Demographics from '../CaregiverDetails/Demographics/Demographics'
import Insurrance from '../CaregiverDetails/Insurrance/Insurrance'
import Guarantor from '../CaregiverDetails/Guarantor/Guarantor'
import CaregiversSummary from '../CaregiverDetails/Summary/CaregiverSummary'
import Documents from '../CaregiverDetails/Documents/Documents'
import Calendar from '../CaregiverDetails/Calendar/Calendar'
import CaregiverPayments from '../CaregiverDetails/CaregiverPayment/CaregiverPayments'
import paymenticon from "../../../assets/img/PAYMENTS.svg"
import { FindFirstChild } from '../../../utils/FindMenuOption'
const CaregiverMenu = () => {

    return [
        {
            name: 'All Caregivers',
            key: 21,
            icon: "",
            right: true,
            subCategoryItems: [
                // {
                //     name: 'Summary',
                //     key: 211,
                //     icon: "icon-claims",
                //     component: <CaregiversSummary/>,
                //     right: true,
                // },
                {
                    name: 'Demographics',
                    key: 212,
                    icon: "icon-Demographics-icon",
                    component: <Demographics/>,
                    right: true,
                    right: FindFirstChild('CareGiver','Demographics')?.ISView,
                },
                {
                    name: 'Payroll',
                    key: 217,
                    icon: "icon-Group-482187",
                    component: <>Payroll</>,
                    right: true,
                    right: FindFirstChild('CareGiver','Payroll')?.ISView,
                },
                // {
                //     name: 'Insurrance',
                //     key: 213,
                //     icon: "icon-umbrella-solid",
                //     component: <Insurrance/>,
                //     right: true,
                // },
                {
                    name: 'Documents',
                    key: 214,
                    icon: "icon-page",
                    component: <Documents />,
                    right: true,
                    right: FindFirstChild('CareGiver','Documents')?.ISView,
                },
                {
                    name: 'Calendar',
                    key: 218,
                    icon: "icon-SCHEDULER",
                    component: <Calendar/>,
                    right: true,
                    right: FindFirstChild('CareGiver','Calender')?.ISView,
                },
                // {
                //     name: 'Guarantor',
                //     key: 215,
                //     icon: "icon-Gurantor-icon",
                //     component: <Guarantor/>,
                //     right: true,
                // },
                // {
                //     name: 'Payments',
                //     key: 216,
                //     icon: "icon-Payments1",
                //     component: <CaregiverPayments/>,
                //     right: true,
                //     // img:true,
                //     // imgSrc:paymenticon,
                // },
            ]
        },
    ]
}


export default CaregiverMenu